/**
 * Casual Classics — Variant Gallery Filter (v3)
 * Works in both carousel and grid media presentations.
 * Grid: hides .product-media-container elements not owned by current variant.
 * Carousel: hides li[ref="media[]"] slides not owned by current variant.
 * Master shots (media not linked to any variant, e.g. hero shots) are ALWAYS visible.
 */

(function () {
  "use strict";

  const DEBUG = true;
  function dlog(...args) { if (DEBUG) console.log("[CC variant gallery]", ...args); }

  const dataEl = document.querySelector('script[type="application/json"][data-cc-variant-gallery]');
  if (!dataEl) {
    dlog("No data script tag found — snippet not rendered. Stopping.");
    return;
  }

  let variantGalleryMap;
  try {
    variantGalleryMap = JSON.parse(dataEl.textContent || "{}");
  } catch (e) {
    console.warn("[CC variant gallery] Could not parse JSON:", e);
    return;
  }

  const variantCount = Object.keys(variantGalleryMap).length;
  dlog(`Loaded gallery data for ${variantCount} variants`);
  if (variantCount === 0) return;

  const numericVariantMap = {};
  for (const gid in variantGalleryMap) {
    const parts = gid.split("/");
    const numeric = parts[parts.length - 1];
    numericVariantMap[String(numeric)] = (variantGalleryMap[gid] || []).map((id) => {
      const idParts = String(id).split("/");
      return idParts[idParts.length - 1];
    });
  }

  const ownedMediaIds = new Set();
  for (const vid in numericVariantMap) {
    numericVariantMap[vid].forEach((id) => ownedMediaIds.add(String(id)));
  }
  dlog(`${ownedMediaIds.size} media items owned by variants`);

  function getSlides() {
    // Carousel mode: <li ref="media[]">
    const carouselSlides = document.querySelectorAll('li[ref="media[]"]');
    // Grid mode: .media-gallery--grid .product-media-container
    const gridContainers = document.querySelectorAll('.media-gallery--grid .product-media-container');
    return [...carouselSlides, ...gridContainers];
  }
  function getSlideMediaId(slide) {
    const inner = slide.querySelector("[data-media-id]");
    return inner ? String(inner.getAttribute("data-media-id")) : null;
  }

  function applyFilter(numericVariantId) {
    const slides = getSlides();
    if (slides.length === 0) { dlog("No slides yet"); return; }
    const visibleForVariant = new Set(numericVariantMap[String(numericVariantId)] || []);
    dlog(`Variant ${numericVariantId}: ${visibleForVariant.size} matching images, ${slides.length} total slides in DOM`);
    let shown = 0, hidden = 0, master = 0;
    slides.forEach((slide) => {
      const mediaId = getSlideMediaId(slide);
      if (!mediaId) { slide.style.display = ""; return; }
      if (!ownedMediaIds.has(mediaId)) { slide.style.display = ""; master++; return; }
      if (visibleForVariant.has(mediaId)) { slide.style.display = ""; shown++; }
      else { slide.style.display = "none"; hidden++; }
    });
    dlog(`Applied: ${shown} shown, ${hidden} hidden, ${master} master`);
    document.documentElement.classList.remove('cc-gallery-loading');
  }

  function getCurrentVariantId() {
    const fromUrl = new URLSearchParams(window.location.search).get("variant");
    if (fromUrl) return fromUrl;
    const variantInput = document.querySelector('input[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function runFilter() {
    const vid = getCurrentVariantId();
    if (vid) applyFilter(vid);
  }

  function tryInitialRun(attempt = 0) {
    if (getSlides().length > 0) runFilter();
    else if (attempt < 20) setTimeout(() => tryInitialRun(attempt + 1), 100);
  }
  tryInitialRun();

  document.addEventListener("variant:change", () => setTimeout(runFilter, 50));
  document.addEventListener("variant:selected", () => setTimeout(runFilter, 50));
  document.addEventListener("variant:update", () => setTimeout(runFilter, 50));
  document.addEventListener("slideshow:select", () => setTimeout(runFilter, 100));
  document.addEventListener("variantchange", () => setTimeout(runFilter, 50));

  document.addEventListener("change", function (e) {
    if (!e.target) return;
    if (e.target.name === "id" ||
        (e.target.closest && e.target.closest('[name="Colour"], [data-variant-picker], variant-picker'))) {
      setTimeout(runFilter, 100);
    }
  });

  let lastSearch = window.location.search;
  setInterval(() => {
    if (window.location.search !== lastSearch) {
      lastSearch = window.location.search;
      runFilter();
    }
  }, 200);

  document.addEventListener("click", function (e) {
    if (!e.target) return;
    const swatch = e.target.closest('[name="Colour"], button[data-option-value], [data-swatch]');
    if (swatch) setTimeout(runFilter, 200);
  });

  dlog("Variant gallery filter initialised (v3 — grid + carousel)");
})();